
const GrievanceHeaderInfo = ({
  grievanceId,
  type,
  receivedOn,
  escalatedOn,
  sla,
  customerName,
  customerPhone,
  customerLan,
  assignedTo,
  previouslyAssignedTo,
  assignedOn,
  currentStage,
  pdfUrl,
}) => {
  const BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  console.log({currentStage});
  
  return (
    <div className="grievance-header-info d-flex flex-wrap w-100">
      <div className="info-column flex-grow-1">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex flex-column">
            <span className="label-text">Grievance ID</span>
            <span className="id-val">{grievanceId}</span>
          </div>
          {sla && (
            <span className={["Breached", "SLA Timed Out"].includes(sla) ? 'sla-timed-out' : 'sla-val'}>SLA: {sla}</span>
          )}
          {type && <span className="badge badge-success light">{type}</span>}
        </div>
        <div className="d-flex flex-column">
          <span className="label-text">{escalatedOn ? 'Escalated On :' : 'Received On :'}</span>
          <span className="value">{escalatedOn || receivedOn}</span>
        </div>
      </div>

      <div className="info-column flex-grow-1 d-flex">
        {customerName && (
          <div className="avatar">
            {customerName
              ? customerName
                  .split(' ')
                  .map((n) => n[0])
                  .join('')
                  .substring(0, 2)
              : 'JD'}
          </div>
        )}
        <div className="d-flex flex-column">
          <span className="id-val">{customerName}</span>
          <span className="value">{customerPhone}</span>
          <span className="value">
            <span className="label-text">LAN : </span>
            {customerLan}
          </span>
          {!customerName && (
            <span className="value mt-3">
              <span className="label-text">Current Stage : </span>
              <span className={`badge badge-${_enum.STATUS_COLOR_MAP[currentStage.toLowerCase()]} light`}>
                {currentStage}
              </span>
            </span>
          )}
          {pdfUrl && (
            <a
              href={pdfUrl ? `${BASE_URL}${pdfUrl}` : 'javascript:void(0);'}
              className="btn btn-primary mt-3"
              {...(pdfUrl ? { disabled: false } : { disabled: true })}
            >
              <i className="fa fa-download me-2"></i>
              Download PDF
            </a>
          )}
        </div>
      </div>

      <div className="info-column flex-grow-1">
        {previouslyAssignedTo && (
          <div className="d-flex flex-column mb-3">
            <span className="label-text">Previously Assigned To</span>
            <span className="value">{previouslyAssignedTo}</span>
          </div>
        )}
        <div className="d-flex flex-column justify-content-between align-items-start gap-3">
          {assignedTo && (
            <div className="d-flex flex-column">
              <span className="label-text">{assignedOn ? 'Assigned On :' : 'Assign To :'}</span>
              <span className="value">{assignedTo || assignedOn}</span>
            </div>
          )}
          {!!customerName && currentStage && (
            <div className="d-flex align-items-center">
              <span className="label-text mb-0 me-2">Current Stage: </span>
              <span
                className={`badge badge-${_enum.STATUS_COLOR_MAP[currentStage.toLowerCase()]} light`}
              >
                {currentStage}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrievanceHeaderInfo;
